import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import BPLineChart from './BPLineChart'
import { base, deepClone, deltaT, generateCircleDot, generateDomainDot } from '../utils'
import BPLoading from './BPLoading'
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { useDispatch, useSelector } from 'react-redux'
// import { updateLinkProfile } from '../Redux/projectsSlice'


function BacklinkProfileProject({ listn }) {
    const [data, setData] = useState({recentBacklinks: []})
    const [project, setProject] = useState(null)
    const [updatedData, setUpdatedData] = useState(null)
    const [groupedUrls, setGroupedUrls] = useState(null)
    const [checks, setChecks] = useState(true)
    const [emptyHQB, setEmptyHQB] = useState(false)
    const [emptyLQB, setEmptyLQB] = useState(false)

    const [isLoading, setIsLoading] = useState(false)

    const pName = window.location.href.split('=').pop().trim().replaceAll('%20', ' ')

    const user = useSelector(state=> state.user.user)
    const projects = useSelector(state=> state.projects.projects)

    const dispatch = useDispatch()

    useEffect(()=> {
      if(projects) {
        let p

        projects.map(proj=> {
          if(proj.name.toLowerCase() === pName && proj.type === 'backlink-profile') {
            p = proj
            return
          }
        })
        setProject(p)
      }
    }, [projects])

    const getData = async () => {
        if(project) {
            setIsLoading(true)
            fetch(`${base}/res`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'blp-',
                url: project.url,
                userId: user.id
              })
            }).then(res=> res.json()).then(data=> {
              setData(data)
              setUpdatedData(data)
              setIsLoading(false)
            })
          }
      }
    
      useEffect(()=> {
        if(project && (!deltaT(project.lastUpdated, 3) || project.data.error || project.data.message || project.data?.recentBacklinks?.length === 0 || project.data.length === 0 || data.length === 0) && checks) {
          setChecks(false)
          getData()
        } else if(project) {
          setData(project.data)
          setChecks(false)
        }
      }, [project])

      useEffect(()=> {
        if(updatedData) {
          let updatedProject = deepClone(project)
          updatedProject.data = data
          updatedProject.lastUpdated = new Date().toUTCString()
          // dispatch(updateLinkProfile({pName: pName, updatedProject: updatedProject}))
          listn()
        }
      }, [updatedData, data])

   

    const projectX = {
        projectName: 'testxyz',
        n: 5,
        type: 'backlink-profile',
        baseUrl: 'example.com',
        data: {
                totalLinks: 165,
                latestLinks: [
                    {url: 'example.com', found: '20 Mar 2024'},
                    {url: 'example.com', found: '20 Mar 2024'},
                    {url: 'example.com', found: '29 Mar 2024'},
                    {url: 'example.com', found: '29 Mar 2024'},
                    {url: 'example.com', found: '29 Mar 2024'},
                    {url: 'example.com', found: '29 Mar 2024'},
                    {url: 'example.com', found: '29 Mar 2024'},
                    {url: 'example.com', found: '29 Mar 2024'},
                    {url: 'example.com', found: '29 Mar 2024'},
                    {url: 'example.com', found: '29 Mar 2024'},
                    {url: 'example.com', found: '29 Mar 2024'},
                    {url: 'example.com', found: '29 Mar 2024'},
                    {url: 'example.com', found: '29 Mar 2024'},
                    {url: 'example.com', found: '29 Mar 2024'},
                    {url: 'example.com', found: '2 Apr 2024'},
                    {url: 'example.com', found: '5 Apr 2024'},
                    {url: 'example.com', found: '5 Apr 2024'},
                    {url: 'example.com', found: '5 Apr 2024'},
                    {url: 'example.com', found: '10 Apr 2024'},
                    {url: 'example.com', found: '15 Apr 2024'},
                    {url: 'example.com', found: '10 Apr 2024'},
                    {url: 'example.com', found: '15 Apr 2024'},
                    {url: 'example.com', found: '10 Apr 2024'},
                    {url: 'example.com', found: '15 Apr 2024'},
                    {url: 'example.com', found: '10 Apr 2024'},
                    {url: 'example.com', found: '15 Apr 2024'},
                    {url: 'example.com', found: '10 Apr 2024'},
                    {url: 'example.com', found: '15 Apr 2024'},
                    {url: 'example.com', found: '15 Apr 2024'},
                    {url: 'example.com', found: '15 Apr 2024'},
                    {url: 'example.com', found: '15 Apr 2024'},
                    {url: 'example.com', found: '15 Apr 2024'},
                ]
            }
    }

    useEffect(()=> {
      if(data.recentBacklinks) {
        let y = Object.values(data?.recentBacklinks?.reduce((acc, { found }) => {
        acc[found] = acc[found] || { found, urls: 0 }; // Initialize URL count to 0 if not exist
        acc[found].urls += 1; // Increment URL count for the found date
        return acc;
        }, {}));

        setGroupedUrls(y)
      }
    }, [data.recentBacklinks])


    useEffect(()=> {
      if(data.recentBacklinks.length !== 0) {
        if(data.hqb.data.length === 10) {
          let checkNA = data.hqb.data.filter(bl=> bl.titleLocation.location === 'NA')

          if(checkNA.length === data.hqb.data.length) {
            setEmptyHQB(true)
          }
        }

        if(data.lqb.length === 10) {
          let checkNA = data.lqb.filter(bl=> bl.titleLocation.location === 'NA')

          if(checkNA.length === data.lqb.length) {
            setEmptyLQB(true)
          }
        }
      }
    }, [data])
    


  return (
    <>
    <BacklinkProfileContainer isLoading={isLoading}>
        {!isLoading && <SettingsContainer>
          <div className='upper-section'>
            <div>
                <h1>{pName}</h1> <h4><span style={{color:'var(--bl-color)'}}>{data?.url}</span> root domain strength is <span style={{color:'var(--bl-color)'}}>{data?.da}%</span></h4>
            <div style={{display: 'flex', flexDirection: 'row', gap: '50px', marginTop: '10px', color: 'gray'}}>
                <span>Nofollow backlinks <span style={{color: 'var(--bl-color)'}}>{data?.hqb?.info?.nofollowBacklinks.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></span>
                <span>Unique backlinks <span style={{color: 'var(--bl-color)'}}>{data?.hqb?.info?.uniqueBacklinks.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></span>
            </div>
            </div>
            <p><span style={{color: '#b3b3b3'}}>Last updated on</span> {project?.lastUpdated} <p style={{color: 'dodgerblue', marginTop: '2px', fontSize: 'small'}}>The next update is scheduled 3 days after the last one</p>
            <p style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', width: '360px', fontSize: 'small', marginTop: '20px'}}><ReportProblemIcon /> <p>Our Backlink Profile Project is in Beta Mode—new insights and optimizations are on the way, but it may not work perfectly yet!</p></p></p>
          </div>
      </SettingsContainer>}

      {!isLoading && <Headings>
      <h2>Backlink Profile Activity Over Time</h2>
      <div>
        <h3>Total links: <span style={{color: 'var(--bl-color)'}}>{data?.hqb?.info?.backlinks.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></h3>
        <h4>Backlink Profile for <span style={{color: 'var(--bl-color)'}}>{data?.url}</span></h4>
      </div>
      </Headings>}
      {!isLoading && <ChartContainer>
        <div className='chart'>
        <BPLineChart data={groupedUrls?.reverse()} />
        </div>
        <div className='right-section'>
            <p className='title'>Recent backlinks sources</p>
        <div className='urls-dates-box'>
            
            {data?.recentBacklinks?.map(l=> {
            return (
                <div className='urls-dates' style={{display: 'flex'}}>
                    <p style={{width: '320px', wordBreak: 'break-all'}}>{l.pageUrl}</p>
                    <p style={{marginLeft: 'auto', width: '200px', textAlign: 'right'}}><span style={{color: '#b2b2b2f0', fontSize: 'small'}}>Found on </span>{l.found}</p>
                </div>
            )
        })}</div>
        </div>

      </ChartContainer>}

      {!isLoading && <BacklinksContainer>
        <h3>High Quality Backlinks</h3>
        <HighQualityBacklinksContainer>
          {!emptyHQB && <>
        <HighQualityBacklinksRes style={{fontWeight: '400', fontSize: 'small'}}>
                <p style={{width: '30px'}}>#</p>
                <p style={{width: '400px', marginRight: '10px'}}>Page Title & Location</p>
                <p style={{width: '250px'}}>Anchor Text & Destination</p>
                <p style={{width: '130px'}}>Page Authority</p>
                <p style={{width: '130px'}}>Domain Authority</p>
                <p style={{width: '160px', marginLeft: 'auto'}}>Found On</p>
            </HighQualityBacklinksRes>
            <div style={{overflowX: 'hidden', overflowY: 'scroll'}}>
            {data?.hqb?.data.map(bl => {
              if(bl.titleLocation.location === 'NA') return
                return (
                    <HighQualityBacklinksRes>
                        <p style={{width: '30px', marginRight: '10px'}}>{bl.rank}</p>
                        <div style={{width: '400px', display: 'flex', flexDirection: 'column', marginRight: '30px', wordWrap: 'break-word'}}>
                            <p>{bl.titleLocation?.title}</p>
                            <p style={{color: 'blue'}}>{bl.titleLocation.location}</p>
                        </div>
                        <div style={{width: '250px', display: 'flex', flexDirection: 'column', wordWrap: 'break-word', marginRight: '20px'}}>
                            <p>{bl.anchorDest.anchorText}</p>
                            <p style={{color: 'blue'}}>{bl.anchorDest.dest}</p>
                        </div>
                        <p style={{width: '130px', display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center'}}>{generateDomainDot(10, bl.pa)}{bl.pa}</p>
                        <p style={{width: '130px', display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center'}}> {generateDomainDot(10, bl.da)}{bl.da}</p>
                        <p style={{width: '160px', marginLeft: 'auto'}}>{bl.found}</p>
                    </HighQualityBacklinksRes>
                )
            })}</div>
            </>}
            {emptyHQB && <p style={{display: 'flex', width: '100%', textAlign: 'left', marginTop: '10px'}}>🚧 Temporary Glitch Alert! 🚧<br/> <br/>

It seems that something went amiss and we couldn’t fetch the data you were looking for. But don’t worry, our tech elves are on it, 
and everything will be back to normal in the next update cycle.</p>}
        </HighQualityBacklinksContainer>

        <h3 style={{marginTop: '60px'}}>Low Quality Backlinks</h3>
        <LowQualityBacklinksContainer>
          {!emptyLQB && <>
        <LowQualityBacklinksRes style={{fontWeight: '400', fontSize: 'small'}}>
                <p style={{width: '30px'}}>#</p>
                <p style={{width: '400px', marginRight: '10px'}}>Page Title & Location</p>
                <p style={{width: '250px'}}>Anchor Text & Destination</p>
                <p style={{width: '130px'}}>Page Authority</p>
                <p style={{width: '130px'}}>Domain Authority</p>
                <p style={{width: '160px', marginLeft: 'auto'}}>Found On</p>
            </LowQualityBacklinksRes>

            <div style={{overflowX: 'hidden', overflowY: 'scroll', height: '95%'}}>
            {data?.lqb?.map(bl => {
              if(bl.titleLocation.location === 'NA') return
                return (
                    <LowQualityBacklinksRes>
                        <p style={{width: '30px', marginRight: '10px'}}>{bl.rank}</p>
                        <div style={{width: '400px', display: 'flex', flexDirection: 'column', marginRight: '30px', wordWrap: 'break-word'}}>
                            <p>{bl.titleLocation?.title}</p>
                            <p style={{color: 'blue'}}>{bl.titleLocation.location}</p>
                        </div>
                        <div style={{width: '250px', display: 'flex', flexDirection: 'column', wordWrap: 'break-word', marginRight: '20px'}}>
                            <p>{bl.anchorDest.anchorText}</p>
                            <p style={{color: 'blue'}}>{bl.anchorDest.dest}</p>
                        </div>
                        <p style={{width: '130px', display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center'}}>{generateCircleDot(10, bl.pa)}{bl.pa}</p>
                        <p style={{width: '130px', display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center'}}> {generateCircleDot(10, bl.da)}{bl.da}</p>
                        <p style={{width: '160px', marginLeft: 'auto'}}>{bl.found}</p>
                    </LowQualityBacklinksRes>
                )
            })}</div>
            </>}
            {emptyLQB && <p>Empty</p>}
        </LowQualityBacklinksContainer>
        <div style={{marginBlock: '100px', height: '100px', color: 'transparent'}}>_</div>
      </BacklinksContainer>}
      
      {isLoading && <BPLoading isUpdating={project.data.length === 0? false: true}/>}
    </BacklinkProfileContainer>
    <div style={{marginBlock: '60px'}}></div>
    </>
  )
}

export default BacklinkProfileProject


const BacklinkProfileContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #f2f2f2;
    flex: 1;
    height: 100%;
    color: var(--bl-color);
    overflow-x: hidden;
    overflow-y: scroll;

    justify-content: ${props=> props.isLoading? 'center': ''};
    align-items: ${props=> props.isLoading? 'center': ''};
`

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const SettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;

  > .upper-section {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  > .upper-section > div > h4 {
    color: gray;
    font-weight: 300;
    margin-top: 20px;
  }

  > .upper-section > div > h1 {
    color: var(--bl-color);
    font-weight: 300;
  }

  > .upper-section > p {
    margin-left: auto;
  }
  `

  const Headings = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    /* margin-left: 20px; */
    align-items: center;
    /* width: 89%; */
    flex: 1;
    background-color: white;
    padding: 10px 25px;

    /* border-bottom: 1px dashed var(--bl-color); */

    border-radius: 0px;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);

    opacity: 0;
    animation: ${fadeInAnimation} 1s ease-in-out forwards;


    > h2 {
        font-weight: 300;
    }

    > div {
        display: flex;
        margin-left: 170px;
        align-items: center;
        gap: 60px;
        flex: 1;
    }

    > div > h3 {
        font-weight: 300;
        color: rgb(171, 171, 171);
    }

    > div > h4 {
        font-weight: 300;
        color: rgb(171, 171, 171);
        margin-left: auto;
    }
  `

  const ChartContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 95%;
    margin-top: 35px;
    height: 400px;
    gap: 10px;

    > .chart {
        width: 620px;
        height: 100%;
    }


    > .right-section > .urls-dates-box {
        display: flex;
        flex-direction: column;
        margin-left: auto;
        overflow-x: hidden;
        overflow-y: auto;
        height: 380px;
        background-color: white;
        border-radius: 0px;
        box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
        /* border: 1px solid #d9d9d9; */
        padding: 10px 5px;

        opacity: 0;
        animation: ${fadeInAnimation} 1s ease-in-out forwards;
    }

    > .right-section > .urls-dates-box > .urls-dates {
        margin-bottom: 17px;
        display: flex;
    }

    > .right-section > .urls-dates-box > .urls-dates > p {
        font-size: smaller;
    }


    > .right-section > .urls-dates-box {
    /* Other styles for the container */
    overflow-y: auto; /* Ensure vertical scrollbar is displayed when needed */
}

> .right-section > .urls-dates-box::-webkit-scrollbar {
    width: 10px; /* Width of the scrollbar */
}

> .right-section > .urls-dates-box::-webkit-scrollbar-track {
    background-color: #d9d9d9; /* Background color of the track */
}

> .right-section > .urls-dates-box::-webkit-scrollbar-thumb {
    background-color: var(--bl-color); /* Color of the scrollbar thumb */
    border-radius: 5px; /* Rounded corners */
}

> .right-section > .urls-dates-box::-webkit-scrollbar-thumb:hover {
    background-color: rgb(100, 147, 100); /* Darken the color on hover */
}


> .right-section > .urls-dates-box > .urls-dates {
        display: flex;
        width: 500px;
        gap: 30px;
    }

    > .right-section > .urls-dates-box > .urls-dates > p {
        width: 300px;
        margin-left: 30px;
    }

    > .right-section > .title {
        color: #b2b2b2f0;
        margin-bottom: 10px;
    }
  `


const BacklinksContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    gap: 20px;
    width: 95%;
    height: 100%;
    margin-top: 50px;
    margin-bottom: 160px !important;
    padding-bottom: 60px;

    > h3 {
        font-weight: 300;
        color: rgb(171, 171, 171);
    }
`


const HighQualityBacklinksContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 3px;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    height: 1000px;
    padding: 10px;
`


const LowQualityBacklinksContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 3px;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    height: 1000px;
    padding: 10px;
`

const HighQualityBacklinksRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);
    justify-content: space-between;
`


const LowQualityBacklinksRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);
    justify-content: space-between;
`